/**
 * 底部主菜单的定义与可见性判定。
 *
 * 抽成纯数据的原因：footer.vue 是单文件组件，没法在 node 里直接跑；
 * 而「内部人员才多一个工作台 tab」这条规则一旦写错，表现是「菜单少一项」——
 * 不报错、不 404，纯靠肉眼发现。所以规则必须能被单测钉住。
 *
 * 注意：这里只管"菜单长什么样"，真正的接口权限由后端把关；
 * 路由守卫（router/index.js 的 requiresInternal）用的是同一条 isInternalUser 判定。
 */

export const TAB_HOME = {
	path: '/',
	text: '首页',
	iconOff: '/static/imgs/shouye.png',
	iconOn: '/static/imgs/shouye_select.png'
}

export const TAB_ROOM = {
	path: '/room',
	text: '房间',
	iconOff: '/static/imgs/room.png',
	iconOn: '/static/imgs/room_select.png'
}

export const TAB_WORKBENCH = {
	path: '/internal/workbench',
	text: '工作台',
	iconOff: '/static/imgs/workbench.png',
	iconOn: '/static/imgs/workbench_select.png'
}

export const TAB_MINE = {
	path: '/mine',
	text: '我的',
	iconOff: '/static/imgs/user.png',
	iconOn: '/static/imgs/user_select.png'
}

/**
 * 是否内部人员。
 * 「我的」页入口（Mine.vue 的 isIotmaxUser）与路由守卫都必须是同一条规则，
 * 三处不一致就会出现"有入口没菜单"或"有菜单点进去被弹回"。
 */
export function isInternalUser(userInfo, isSuperRoot) {
	if (isSuperRoot === true) return true
	return Number(userInfo && userInfo.is_iotmax) === 1
}

/** @returns {Array} 菜单项，顺序即显示顺序；工作台在「我的」之前 */
export function buildTabs(userInfo, isSuperRoot) {
	const tabs = [TAB_HOME, TAB_ROOM]
	if (isInternalUser(userInfo, isSuperRoot)) tabs.push(TAB_WORKBENCH)
	tabs.push(TAB_MINE)
	return tabs
}

/**
 * 点当前页要不要真的跳转。
 * vue-router 3 里 push 到当前路由会抛 NavigationDuplicated（未捕获的 Promise），
 * 用户看到的是"点了没反应"，控制台一片红。
 */
export function shouldNavigate(currentPath, targetPath) {
	return currentPath !== targetPath
}
